//
// Organization Tags
//
export default [
  'hafnarfjordur', 'kopavogur', 'vestmannaeyjar', 'vinakot',
  'framsyn-menntun', 'beanfee',
];
